module.exports = __webpack_public_path__ + "resource/img/banner_news.jpg?295a9133c4b1990a24aa88590dee31ca";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner_news.jpg
// module id = 187
// module chunks = 36